import { createApi } from '@shared/redux/createApi';

const tags = {
  getSmsproBalance: 'getSmsproBalance',
};

export const smsproApi = createApi({
  reducerPath: 'smsproApi',
  tagTypes: [tags.getSmsproBalance],

  endpoints: (builder) => ({
    getSmsproBalance: builder.query({
      query: () => {
        return ({
          method: 'get', url: `/admin/smspro/balance`,
        });
      },
      providesTags: [tags.getSmsproBalance],
    }),
  }),
});

export const { useGetSmsproBalanceQuery } = smsproApi;
